import React from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import activities from "localDatabase/activities2025";
import style from "./ActivitiesSectionStyle";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ContainerFullHeight from "components/ContainerFullHeight/ContainerFullHeight";
import ActivitiesInfo from "components/ActivitiesInfo/ActivitiesInfo";

const useStyles = makeStyles(style);

export default function ActivitiesSection({ id, t }) {
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width:681px)");
  return (
    <ContainerFullHeight
      alignItems="start"
      id={id}
      bgColor="beige"
      paddingTop={isMobile ? "80px" : "200px"}
      paddingBottom={isMobile ? "80px" : "200px"}
    >
      <div className={classes.container}>
        <GridContainer>
          <GridItem xs={12}>
            <h2 className={classes.title}>{t("activitiesTitle")}</h2>
          </GridItem>
          {activities.map((act, index) => (
            <GridItem xs={12} md={4} key={index}>
              <ActivitiesInfo activity={act} />
            </GridItem>
          ))}
        </GridContainer>
      </div>
    </ContainerFullHeight>
  );
}
